import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/website_entertainment_statuses/{?id}')
abstract class AbstractWebsiteEntertainmentStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_WebsiteEntertainmentStatusReference;
}

export default AbstractWebsiteEntertainmentStatusModel;
